export const parseNameParam = (name: string | (string | null)[] | null) => {
	if (typeof name === 'string') {
		return name;
	}
	if (Array.isArray(name)) {
		return name.join(',');
	}
	return '';
};
